import { TaxiCompanyApiTaxiCompanyDeleteRequest } from "../../openapi/api";
import appApiClient from "./coreApiClient";
import useBaseMutation from "./useBaseMutation";

export const useTaxiCompanyDeleteMutation = () =>
  useBaseMutation({
    mutationFn: (req: TaxiCompanyApiTaxiCompanyDeleteRequest, config) =>
      appApiClient.taxiCompanyApi.taxiCompanyDelete(req, config),
  });
